import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { Overline } from "../components/primitives";

const META = {
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
  cancellation: "Cancellation & Refund Policy",
  waiver: "Travel Waiver & Release of Liability",
  insurance: "Travel Insurance Acknowledgment",
};
const ORDER = ["privacy", "terms", "cancellation", "waiver", "insurance"];

export default function Legal() {
  const { slug } = useParams();
  const key = META[slug] ? slug : "privacy";
  const [docs, setDocs] = useState({});

  useEffect(() => { api.get("/content/legal").then((r) => setDocs(r.data)).catch(() => {}); }, []);

  const raw = docs[key] || "";
  // Render plain-text with "Heading\nBody\n\n" blocks.
  const blocks = raw.split("\n\n").map((chunk) => {
    const lines = chunk.split("\n");
    return { heading: lines[0], body: lines.slice(1).join(" ") };
  });

  return (
    <div className="pt-24 md:pt-32 pb-28">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Overline>Legal</Overline>
        <h1 className="mt-3 font-display font-extrabold tracking-tighter text-4xl md:text-5xl">{META[key]}</h1>
        <div className="mt-4 text-sm text-foreground/50">Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</div>
        <div className="mt-10 space-y-8">
          {blocks.map((b, i) => (
            <div key={i}>
              {b.heading && <h2 className="font-display font-bold text-xl">{b.heading}</h2>}
              {b.body && <p className="mt-2 text-foreground/75 leading-relaxed">{b.body}</p>}
            </div>
          ))}
          {!raw && <p className="text-foreground/60">Loading…</p>}
        </div>
        <div className="mt-12 flex flex-wrap gap-3 text-sm">
          {ORDER.map((k) => (
            <Link key={k} to={`/legal/${k}`} className={`rounded-full px-4 py-2 border ${k === key ? "bg-primary text-white border-primary" : "border-black/10 hover:border-primary"}`}>{META[k]}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}
